import { Expose } from "class-transformer";
import type { UUID } from "crypto";
import type { DisabilityTypeEnum } from "../../enums/disability-type.enum";
import type { IDisability } from "./disability.entity.interface";

export class Disability implements IDisability {
  @Expose()
  id!: UUID;

  @Expose()
  disabilityType!: DisabilityTypeEnum;

  @Expose()
  disabilityPercentage?: number;
}
